import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { AppConfig } from "../../../../configs/app";
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { CommonService } from "../../../../services/common.service";
import { ReservationService } from "../../../../services/reservation.service";
import { PaymentService } from "../../../../services/payment.service";
import { CartService } from "../../../../services/cart.service";
import { AnalyticsService } from "../../../../services/analytics.service";

declare var Cleave: any;
declare var gmoAuthOrderDecision: any; /* GMO */

@Component({
  selector: "page-reserve-payment-index",
  templateUrl: "./index.component.html",
})
export class PageReservePaymentIndexComponent implements OnInit {
  public postData: any;
  public creditCardForm: FormGroup;
  public postpayForm: FormGroup;
  public couponForm: FormGroup;
  public paymentData: any = {};
  public cartData: any;
  public usePaymentType: number = 1;
  //    public usePaymentType: number = 2;
  public forceUsingCreditCard: boolean = false;
  public canUseCreditCard: boolean = true;
  public paymentDate: any = {};
  public couponData: any = {};
  public paymentViewClass = '';

  public useZurich = false;

  /* CUSTOM VALIDATOR */
  public myValidator: any = {};

  public paymentViewCount: number = 1;

  public $: any;
  public moment: any;
  public _: any;

  /* BUS SETTINGS */
  public busSettings: any = {};

  /* FOR TEMPORARY ASSIGNING */
  public tempData: any = {};

  constructor(
    public ref: ChangeDetectorRef,
    public appConfig: AppConfig,
    public formBuilder: FormBuilder,
    public commonService: CommonService,
    public reservationService: ReservationService,
    public paymentService: PaymentService,
    public cartService: CartService,
    private analyticsService: AnalyticsService
  ) {
    let self = this;
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();

    /* CUSTOM VALIDATOR */
    this.myValidator.minMaxLength = function (control: AbstractControl): any {
      if (
        control.value &&
        (control.value.toString().length < 3 ||
          control.value.toString().length > 4)
      ) {
        return { minMaxLength: true };
      }
      return null;
    };

    /* CUSTOM MIN LENGTH */
    this.myValidator.minLength = function (control: AbstractControl): any {
      if (control && control.value) {
        let value = control.value.toString().replace(/[-]/g, "");
        if (value.length < 15) {
          return { minLength: true };
        }
      }
      return null;
    };

    /**
     * [F-11] カード有効期限バリデーション
     *
     * 修正前の問題:
     *   check_ym の生成で moment("2026-5", "YYYYMM") のようにハイフン入り文字列を
     *   "YYYYMM" フォーマットでパースしていた。
     *
     *   momentの「寛容パース（non-strict parsing）」とは:
     *     moment("2026-5", "YYYYMM") のように入力文字列とフォーマットが一致しなくても、
     *     momentがエラーを出さず「なんとなく」解釈してしまう挙動のこと。
     *     例: フォーマット "YYYYMM" は "202605" のような6桁連続数字を期待するが、
     *     "2026-5" を渡すとハイフンを無視して "20265" → 5桁として解釈を試みる。
     *     結果は環境やバージョンによって異なり、正しい月が得られる保証がない。
     *     moment公式でも非推奨とされており、コンソールに Deprecation warning が出る。
     *     （第3引数に true を渡すと厳格パースになるが、この箇所では使われていなかった）
     *
     *   加えて 1桁月（1〜9月）でゼロパディングがないため、
     *   "2026-5" の "5" が YYYYMM の MM 部分と正しくマッピングされない。
     *
     * 修正内容:
     *   文字列パースを使わず、moment().startOf('month') で確実に現在月の月初を取得。
     *   入力値の MMYY も startOf('month') で月初に揃えて比較する。
     */
    this.myValidator.cardDate = function (control: AbstractControl): any {
      let date = control.value.toString().replace(/[/]/g, "");
      if (date.length < 4) {
        return { cardDate: true };
      }

      // 現在年月の月初タイムスタンプ（確実に月初 00:00:00 を取得）
      let check_ym = self.moment().startOf('month').valueOf();

      /* CHECK INVALID DATE */
      if (
        !self.moment(date, "MMYY", true).isValid() ||
        self.moment(date, "MMYY").startOf('month').valueOf() < check_ym
      ) {
        return { cardDate: true };
      }
      return null;
    };

    this.myValidator.isNumeric = function (control: AbstractControl): any {
      if (
        control.value &&
        control.value != "" &&
        !self.commonService.isNumeric(control.value)
      ) {
        return { isNumeric: true };
      }
      return null;
    };

    this.myValidator.cardOwner = function(control: AbstractControl): any {
      if (control.value && control.value != "" && !self.commonService.checkAlpha(control.value)) {
        return {cardOwner: true};
      }
      return null;
    };
    /* END */
  }

  async ngOnInit() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    this.commonService.removeBatchData([
      this.appConfig.reservation.reservationCompleteDataSessionName,
    ]);

    /* GET BUS SETTINGS */
    this.busSettings = this.commonService.getData(
      this.commonService.appConfig.site.settingSessionName
    );

    this.postData = this.reservationService.getReservationData();

    this.cartData = this.cartService.getCartData();
    this.forceUsingCreditCard =
      this.reservationService.checkForcingPaymentByCreditCard(this.cartData);

    /* CHECK IF HAS DATA */
    if (this._.isEmpty(this.postData)) {
      return this.commonService.redirectToRoute(
        this.commonService.routePaths.pagePlanList
      );
    }

    /* CHECK SAVED DATA */
    this.usePaymentType = this.postData.payment_method
      ? this.postData.payment_method
      : this.usePaymentType;
    if (!this._.has(this.busSettings, "veritrans.token_api_url")) {
      /* Credit Card payment is not available */
      this.canUseCreditCard = false;
      if (!this.forceUsingCreditCard) {
        this.usePaymentType = this.appConfig.reservation.paymentType.bank;
      }
    }

    this.useZurich = Boolean(this.postData.zr_use_insurance);

    /* INIT FORM DATA */
    /* PCI-DSS: カード番号・有効期限・CVVはlocalStorageに保存しない（再入力必須） */
    this.creditCardForm = this.formBuilder.group({
      card_name: [
        this.postData.card_owner,
        [
          Validators.required,
          this.myValidator.cardOwner
        ]
      ],
      card_full_number: [
        "",
        [Validators.required, this.myValidator.minLength],
      ],
      card_month_year: [
        "",
        [Validators.required, this.myValidator.cardDate],
      ],
      card_secret_number: [
        "",
        [
          Validators.required,
          this.myValidator.isNumeric,
          this.myValidator.minMaxLength,
          Validators.maxLength(4),
        ],
      ],
    });

    this.couponForm = this.formBuilder.group({
      coupon: [this.postData.coupon_code],
    });

    /* CHECK POSTPAY TEL */
    if (!this.postData.postpay_tel && this.postData.c_tel) {
      if (
        this.postData.c_tel.substr(0, 1) == "0" &&
        this.postData.c_tel.substr(2, 1) == "0"
      ) {
        this.postData.postpay_tel = this.postData.c_tel;
      }
    }
    /* END */
    this.postpayForm = this.formBuilder.group({
      postpay_zipcode: [
        this.postData.postpay_zipcode,
        [
          Validators.required,
          this.myValidator.isNumeric,
          Validators.minLength(7),
          Validators.maxLength(7),
        ],
      ],
      postpay_prefecture: [
        this.postData.postpay_prefecture,
        [Validators.required],
      ],
      postpay_city: [this.postData.postpay_city, [Validators.required]],
      postpay_street: [this.postData.postpay_street, [Validators.required]],
      postpay_apartment: [this.postData.postpay_apartment],
      postpay_tel: [
        this.postData.postpay_tel,
        [
          Validators.required,
          this.myValidator.isNumeric,
          Validators.minLength(10),
          Validators.maxLength(11),
        ],
      ],
    });

    this.tempData.formSubmitted = false;
    this.tempData.errorCreditCard = this.commonService.getNRemoveData(
      this.appConfig.reservation.errorCreditCardSessionName
    );

    /* CALCULATE PAYMENT DATE */
    this.calculatePaymentDate();

    /* CALCULATE TOTAL AMOUNT */
    await this.calculatePostpayTotalAmount();
    if (this.usePaymentType == this.appConfig.reservation.paymentType.postpay) {
      this.paymentService.gmoInit();
    }
    /* END */

    if(!this.forceUsingCreditCard){
      //bank view
      this.paymentViewCount++;
    }

    /* CHECK AVAILABLE PAYMENT METHODS POSTPAY */
    this.checkAvailablePaymentMethodsPostPay();

    /* CHECK AVAILABLE PAYMENT METHODS PAYPAY */
    this.checkAvailablePaymentMethodsPayPay();

    /* CHECK AVAILABLE PAYMENT METHODS PAIDY */
    this.checkAvailablePaymentMethodsPaidy();

    /* FALLBACK UNAVAILABLE PAYMENT METHOD */
    /* 後払いを再開する場合は、上記3つの利用可否チェックをこのブロックごと gmoInit() より前へ移動すること */
    this.fallbackUnavailablePaymentMethod();

    switch (this.paymentViewCount){
      case 1:
        this.paymentViewClass = 'w-100';
        break;
      case 2:
        this.paymentViewClass = 'payment-conf-box2';
        break;
      case 3:
        this.paymentViewClass = 'payment-conf-box3';
        break;
      case 4:
        this.paymentViewClass = '';
        break;
      default :
        break;
    }

    /* EXECUTE INLINE JAVASCRIPT */
    this.inlineJS();

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();
  }

  /**
   * [F-10] 後払い（PostPay）利用可否チェック
   *
   * 修正前の問題:
   *   forループ内で paymentViewCount++ していたため、カートに複数便がある場合
   *   1つの決済手段に対してアイテム数分だけインクリメントされていた。
   *   例: カート3便でPostPay/PayPay/Paidy全有効 → paymentViewCount = 1+1+3+3+3 = 11
   *   → switch文のどのcaseにも該当せずレイアウトクラスが空になる。
   *
   * 修正内容:
   *   ループ完了後、利用可能と判定された場合に1回だけインクリメントする。
   */
  checkAvailablePaymentMethodsPostPay() {
    /* POSTPAY */
    if (
      this.postData.zr_use_insurance ==
      this.appConfig.reservation.useInsuranceOn
    ) {
      this.tempData.availablePostPay = false;
      return;
    }
    if (this._.get(this.busSettings, "payment.postpay.available") == 1) {
      let minTime = this.moment(this.moment().format("YYYY-MM-DD"))
        .add(this.busSettings.payment.postpay.minDays, "days")
        .valueOf();
      let maxTime = this.moment(this.moment().format("YYYY-MM-DD"))
        .add(this.busSettings.payment.postpay.maxDays, "days")
        .valueOf();

      let allInRange = true;
      for (let item of this.cartData) {
        let boardingTime = this.moment(item.targetDay).valueOf();

        if (boardingTime >= minTime && boardingTime <= maxTime) {
          // この便は範囲内 — 次の便もチェック
        } else {
          allInRange = false;
          break;
        }
      }
      if (allInRange && this.cartData.length > 0) {
        this.tempData.availablePostPay = true;
        this.paymentViewCount++;
      } else {
        this.tempData.availablePostPay = false;
      }
    }
    /* END */
  }

  /**
   * [F-10] PayPay利用可否チェック
   * 修正内容: PostPayと同じ問題 — ループ内の paymentViewCount++ を
   * ループ完了後の1回に修正。詳細は checkAvailablePaymentMethodsPostPay() のコメント参照。
   */
  checkAvailablePaymentMethodsPayPay() {
    /* PAYPAY */
    if (this._.get(this.busSettings, "payment.paypay.available") == 1) {
      let minTime = this.moment(this.moment().format("YYYY-MM-DD"))
        .add(this.busSettings.payment.paypay.minDays, "days")
        .valueOf();
      let maxTime = this.moment(this.moment().format("YYYY-MM-DD"))
        .add(this.busSettings.payment.paypay.maxDays, "days")
        .valueOf();

      let allInRange = true;
      for (let item of this.cartData) {
        let boardingTime = this.moment(item.targetDay).valueOf();
        if (boardingTime >= minTime && boardingTime <= maxTime) {
          // この便は範囲内 — 次の便もチェック
        } else {
          allInRange = false;
          break;
        }
      }
      if (allInRange && this.cartData.length > 0) {
        this.tempData.availablePayPay = true;
        this.paymentViewCount++;
      } else {
        this.tempData.availablePayPay = false;
      }
    }
    /* END */
  }

  /**
   * [F-10] Paidy利用可否チェック
   * 修正内容: PostPayと同じ問題 — ループ内の paymentViewCount++ を
   * ループ完了後の1回に修正。詳細は checkAvailablePaymentMethodsPostPay() のコメント参照。
   */
  checkAvailablePaymentMethodsPaidy() {
    /* PAIDY */
    if (this._.get(this.busSettings, "payment.paidy.available") == 1) {
      let minTime = this.moment(this.moment().format("YYYY-MM-DD"))
        .add(this.busSettings.payment.paidy.minDays, "days")
        .valueOf();
      let maxTime = this.moment(this.moment().format("YYYY-MM-DD"))
        .add(this.busSettings.payment.paidy.maxDays, "days")
        .valueOf();

      let allInRange = true;
      for (let item of this.cartData) {
        let boardingTime = this.moment(item.targetDay).valueOf();
        if (boardingTime >= minTime && boardingTime <= maxTime) {
          // この便は範囲内 — 次の便もチェック
        } else {
          allInRange = false;
          break;
        }
      }
      if (allInRange && this.cartData.length > 0) {
        this.tempData.availablePaidy = true;
        this.paymentViewCount++;
      } else {
        this.tempData.availablePaidy = false;
      }
    }
    /* END */
  }

  fallbackUnavailablePaymentMethod() {
    const paymentType = this.appConfig.reservation.paymentType;
    const availablePaymentMethods = {};
    availablePaymentMethods[paymentType.creditCard] = this.canUseCreditCard;
    availablePaymentMethods[paymentType.bank] = !this.forceUsingCreditCard;
    availablePaymentMethods[paymentType.postpay] = Boolean(
      this.tempData.availablePostPay
    );
    availablePaymentMethods[paymentType.paypay] = Boolean(
      this.tempData.availablePayPay
    );
    availablePaymentMethods[paymentType.paidy] = Boolean(
      this.tempData.availablePaidy
    );

    if (availablePaymentMethods[this.usePaymentType]) {
      return;
    }

    if (this.canUseCreditCard) {
      this.usePaymentType = paymentType.creditCard;
      this.tempData.paymentMethodFallbackMessage =
        "以前選択されていた支払方法は現在ご利用いただけないため、支払方法を「クレジットカード」に変更しました。内容をご確認ください。";
    } else if (!this.forceUsingCreditCard) {
      this.usePaymentType = paymentType.bank;
      this.tempData.paymentMethodFallbackMessage =
        "以前選択されていた支払方法は現在ご利用いただけないため、支払方法を「コンビニ・ネットバンク決済」に変更しました。内容をご確認ください。";
    } else {
      this.tempData.paymentMethodUnavailable = true;
      this.tempData.paymentMethodUnavailableMessage =
        "ただいまお支払い手続きをご利用いただけません。お手数ですが、時間をおいて再度お試しください。";
    }
  }

  async calculatePostpayTotalAmount() {
    let priceCalculation: any = {};
    this.postData.payment_method = this.usePaymentType;
    await this.reservationService.calculateTotalAmount(
      this.cartData,
      null,
      priceCalculation,
      this.postData,
      this.couponData,
      null,
      null,
      null
    );

    /* ADD SOME EXTRA PAYMENT DATA */
    if (this._.isEmpty(this.paymentData)) {
      this.paymentData = {};
    }
    this.paymentData.canPay = true;
    this.paymentData.totalAmount = priceCalculation.totalCartPrice;
    if (this.usePaymentType == this.appConfig.reservation.paymentType.postpay) {
      const minAmount = this._.get(this.busSettings, "payment.postpay.minAmount");
      const maxAmount = this._.get(this.busSettings, "payment.postpay.maxAmount");
      if (
        minAmount == null ||
        maxAmount == null ||
        priceCalculation.totalCartPrice < minAmount ||
        priceCalculation.totalCartPrice > maxAmount
      ) {
        this.paymentData.canPay = false;
      }
    }
  }

  /* SUBMIT */
  async onSubmit() {
    /* SHOW PAGE LOADER */
    this.commonService.showPageLoader("読み込み中...");

    let self = this;
    this.tempData.errorCreditCard = null;
    this.tempData.verifiedPostPay = null;
    this.tempData.errorPostPay = null;

    /* FORM ZEN TO HAN */
    this.commonService.convertFormInputZenToHan(this.creditCardForm);
    this.formValidationInit();

    /* ANALYZE DATA BY PAYMENT METHOD */
    let returnData = null;
    if (this.usePaymentType === this.appConfig.reservation.paymentType.bank) {
      /* BANK */
      returnData = this.doSubmitBank();
    } else if (
      this.usePaymentType === this.appConfig.reservation.paymentType.creditCard
    ) {
      /* CREDIT CARD */
      returnData = this.doSubmitCreditCard();
    } else if (
      this.usePaymentType === this.appConfig.reservation.paymentType.postpay
    ) {
      /* POSTPAY */
      returnData = await this.doSubmitPostPay();
    } else if (
      this.usePaymentType === this.appConfig.reservation.paymentType.paypay
    ) {
      /* PAYPAY */
      returnData = await this.doSubmitPaypay();
    } else if (
      this.usePaymentType === this.appConfig.reservation.paymentType.paidy
    ) {
      /* PAIDY */
      returnData = await this.doSubmitPaidy();
    }
    if (returnData === false) return false;

    this.postData.payment_method = this.paymentData.payment_method;
    /* END */

    delete this.postData.coupon_code;
    delete this.postData.coupon_code2;

    /* COUPON DATA */
    if (this.couponForm.value.coupon) {
      if (this.cartData.length > 1) {
        this.postData["coupon_code"] = this.couponForm.value.coupon;
        this.postData["coupon_code2"] = this.couponForm.value.coupon;
        this.postData["couponDetail"] = "";
      } else {
        this.postData["coupon_code"] = this.couponForm.value.coupon;
        this.postData["couponDetail"] = "";
      }

      let returnCouponData = await this.reservationService.couponChecking(
        this.postData["coupon_code"]
      );

      if (returnCouponData.status == "success") {
        if (this.useZurich && returnCouponData.data.discount > 0) {
          delete this.postData.use_coupon;
          this.commonService.removeData(
            this.appConfig.reservation.couponDataName
          );
          this.couponData.message = this.commonService.translate(
            "insurance.zurich.cannotBeUsedWithCoupon"
          );
          this.commonService.hidePageLoader();
          return false;
        }
        this.postData.use_coupon = this.appConfig.reservation.useCoupon;
        this.couponData = returnCouponData.data;
        this.reservationService.saveCouponData(this.couponData);
      } else {
        delete this.postData.use_coupon;
        this.commonService.removeData(
          this.appConfig.reservation.couponDataName
        );
        this.couponData.message = returnCouponData.message;
        this.commonService.hidePageLoader();
        return false;
      }
    }

    /* SAVE RESERVATION DATA */
    this.reservationService.saveReservationData(this.postData);

    /* VERITRANS CHECK */
    if (
      this.usePaymentType === this.appConfig.reservation.paymentType.creditCard
    ) {
      /* BANK */

      /* PCI-DSS: カード情報はフォームから直接読み取り、Veritransにのみ渡す
         （postData経由にするとlocalStorageに保存されてしまうため） */
      /* [CR-FRONT-06 確認済み] card_expire のフォーマットについて:
         - Veritrans4G Token API は MM/YY 形式を受け付ける
           (根拠: create_veritrans_token_test.ctp 162行目「※形式：MM/YY」)
         - フォーム入力値 card_month_year はそのまま MM/YY 形式
         - PCI修正(e7c25c2d)前に存在した YYYYMM 変換は localStorage 保存用であり
           Veritrans送信用ではなかったため、削除して問題ない */
      const cardFullNumber = this.creditCardForm.controls.card_full_number.value;
      let veritransData = await this.paymentService.getVeritransToken({
        lang: "ja",
        card_number: cardFullNumber.replace(/-/g, ""),
        card_expire: this.creditCardForm.controls.card_month_year.value,
        security_code: this.creditCardForm.controls.card_secret_number.value,
      });

      /* HIDE PAGE LOADER */
      self.commonService.hidePageLoader();

      if (veritransData.status == "success") {
        this.postData.session_token = veritransData.token;
        this.postData.token = veritransData.token;
        this.postData.token_expire_date = veritransData.token_expire_date;

        /* SAVE RESERVATION DATA */
        this.reservationService.saveReservationData(this.postData);
        this.analyticsService.addPaymentInfo(this.postData, this.cartData);

        /* GO TO NEXT PAGE */
        self.commonService.redirectToRoute(
          self.commonService.routePaths.pageReserveCheckout
        );
      } else {
        self.showCreditCardErrorMessage({
          infoCode: veritransData.code,
          info: veritransData.message,
        });
      }
    } else {
      /* HIDE PAGE LOADER */
      this.commonService.hidePageLoader();
      this.analyticsService.addPaymentInfo(this.postData, this.cartData);

      /* GO TO NEXT PAGE */
      this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReserveCheckout
      );
    }
  }

  /* COMBANI */
  doSubmitBank() {
    /* CLEAR CREDIT CARD & POSTPAY INFO */
    this.postData = this._.omit(this.postData, [
      "card_owner",
      "card_no",
      "card_expdate",
      "card_cvv2",
      "postpay_gmoID",
      "postpay_orderID",
      "postpay_zipcode",
      "postpay_prefecture",
      "postpay_city",
      "postpay_street",
      "postpay_apartment",
      "postpay_tel",
    ]);

    this.paymentData.payment_method =
      this.appConfig.reservation.paymentType.bank;
  }

  /* PAYPAY */
  async doSubmitPaypay() {
    /* CLEAR CREDIT CARD & POSTPAY INFO */
    this.postData = this._.omit(this.postData, [
      "card_owner",
      "card_no",
      "card_expdate",
      "card_cvv2",
      "postpay_gmoID",
      "postpay_orderID",
      "postpay_zipcode",
      "postpay_prefecture",
      "postpay_city",
      "postpay_street",
      "postpay_apartment",
      "postpay_tel",
    ]);

    this.paymentData.payment_method =
      this.appConfig.reservation.paymentType.paypay;
  }

  /* PAIDY */
  doSubmitPaidy() {
    /* CLEAR CREDIT CARD & POSTPAY INFO */
    this.postData = this._.omit(this.postData, [
      "card_owner",
      "card_no",
      "card_expdate",
      "card_cvv2",
      "postpay_gmoID",
      "postpay_orderID",
      "postpay_zipcode",
      "postpay_prefecture",
      "postpay_city",
      "postpay_street",
      "postpay_apartment",
      "postpay_tel",
    ]);

    this.paymentData.payment_method =
      this.appConfig.reservation.paymentType.paidy;
  }

  /* CREDIT CARD */
  doSubmitCreditCard() {
    this.tempData.formSubmitted = true;

    /* CHECK VALIDATORS */
    if (this.creditCardForm.invalid) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop: this.$(".form-error:visible").first().offset().top - 40,
          },
          200
        );
      }
      /* HIDE PAGE LOADER */
      this.commonService.hidePageLoader();
      return false;
    }

    this.paymentData.payment_method =
      this.appConfig.reservation.paymentType.creditCard;

    /* PCI-DSS: カード番号・有効期限・CVVはlocalStorageに保存しない。
       カード名義のみ保存し、他はフォームから直接Veritransに渡す */
    this.postData["card_owner"] = this.creditCardForm.controls.card_name.value;
  }

  /* POSTPAY */
  async doSubmitPostPay() {
    this.tempData.formSubmitted = true;

    /* CHECK VALIDATORS */
    if (this.postpayForm.invalid) {
      /* SCROLL TO THE FIRST ERROR FORM */
      if (this.$(".form-error:visible").length !== 0) {
        this.$("html, body").animate(
          {
            scrollTop: this.$(".form-error:visible").first().offset().top - 40,
          },
          200
        );
      }
      /* HIDE PAGE LOADER */
      this.commonService.hidePageLoader();
      return false;
    }

    let newPostData = {
      ...this.paymentData,
      ...this.postData,
      ...this.postpayForm.value,
    };

    /* HIDE PAGE LOADER */
    this.commonService.hidePageLoader();

    /* LAUNCH GMO SMS */
    if (!this.postData.postpay_gmoID) {
      await this.paymentService.gmoCreateTransaction(
        newPostData,
        this.cartData
      );
      if (typeof gmoAuthOrderDecision == "function") {
        gmoAuthOrderDecision();
      } else {
        /* Processing when a reading error occurs */
        this.tempData.errorPostPay = {};
        this.tempData.errorPostPay.message =
          "現在、GMO接続を初期化できません。 もう一度試すか、ページをリロードしてください。";
      }
      return false;
    }

    this.postData = newPostData;

    this.paymentData.payment_method =
      this.appConfig.reservation.paymentType.postpay;
  }
  /* END OF SUBMITTING */

  changeInputValue(event: any, inputName: any) {
    if (
      this.usePaymentType === this.appConfig.reservation.paymentType.creditCard
    ) {
      this.creditCardForm.controls[inputName].setValue(event.target.value);
    } else if (
      this.usePaymentType === this.appConfig.reservation.paymentType.postpay
    ) {
      this.postpayForm.controls[inputName].setValue(event.target.value);
    }
  }

  calculatePaymentDate() {
    let boardDay = this.moment(this.postData["1_dpt_ymd"]).format("YYYY-MM-DD");
    this.paymentDate.date = this.reservationService.getPaymentDay(
      this.appConfig.reservation.paymentType.bank,
      boardDay
    );
    this.paymentDate.weekDay = this.commonService.getDayLabel(
      this.moment(this.paymentDate.date).day()
    );

    /* SAVE PAYMENT CALCULATION DATA */
    this.reservationService.savePaymentCalcData(this.paymentDate);
  }

  showCreditCardErrorMessage(data: any = null) {
    if (data) {
      this.tempData.errorCreditCard = {
        info: data.info,
        info_code: data.infoCode,
      };
    } else {
      this.tempData.errorCreditCard = {
        info: "現在、クレジットカードをご利用いただけません。恐れ入りますが別の決済方法をご利用ください。",
        info_code: 99,
      };
    }

    this.commonService.scrollToTop();
  }

  /* GMO */
  async searchAddressByZipCode() {
    if (
      this.postpayForm.controls.postpay_zipcode.value &&
      this.postpayForm.controls.postpay_zipcode.value.length >= 7
    ) {
      this.tempData.zipcodeSearching = true;
      let zipcodeData = await this.reservationService.searchAddressByZipCode({
        zipcode: this.postpayForm.controls.postpay_zipcode.value,
      });

      if (!this._.isEmpty(zipcodeData)) {
        zipcodeData = zipcodeData[0];
        this.postpayForm.controls.postpay_prefecture.setValue(
          zipcodeData.address1
        );
        this.postpayForm.controls.postpay_city.setValue(zipcodeData.address2);
        this.postpayForm.controls.postpay_street.setValue(zipcodeData.address3);
      }
    } else {
      this.postpayForm.controls.postpay_prefecture.setValue("");
      this.postpayForm.controls.postpay_city.setValue("");
      this.postpayForm.controls.postpay_street.setValue("");
    }
    delete this.tempData.zipcodeSearching;
  }

  /* GMO VERIFIED CALLBACK */
  gmoVerifiedCallback(res: any) {
    if (
      res.result == "OK" &&
      res.transactionResult.smsAuthenticationResult == "OK" &&
      res.transactionResult.authorResult == "OK"
    ) {
      /* SUCCESS */
      /* SET GMO TRANSACTION ID TO POST DATA */
      this.postData.postpay_orderID = res.transactionResult.shopTransactionId;
      this.postData.postpay_gmoID = res.transactionResult.gmoTransactionId;

      /* SHOW SUCCESS MESSAGES */
      this.tempData.verifiedPostPay = {};
      this.tempData.verifiedPostPay.message = "payment.error.gmoAuthSuccess";
    } else {
      /* FAILED */
      /* SHOW ERROR MESSAGES */
      this.tempData.errorPostPay = {};

      if (this._.has(res, "errors.error")) {
        let errorMsg = ``;
        for (let error of res.errors.error) {
          errorMsg += `(${error.errorCode}) ${error.errorMessage}<br>`;
        }

        this.tempData.errorPostPay.message = errorMsg;
      } else {
        this.tempData.errorPostPay.message = "payment.error.gmoAuthError";
      }
    }

    this.ref.detectChanges();
  }
  /* GMO ENDS */

  goToPreviousPage() {
    if (this.postData.goToInsurancePage) {
      this.commonService.redirectToRoute(
        this.commonService.routePaths.pageReserveInsurance
      );
    } else {
      if (this.postData.hasOwnProperty("representationType_plan2")) {
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageReservePassengerPlan2
        );
      } else {
        this.commonService.redirectToRoute(
          this.commonService.routePaths.pageReserveInsurance
        );
      }
    }
  }

  inlineJS() {
    let self = this;

    /* GMO SMS AUTHENTICATION RESULT */
    window["gmoSmsAuthResult"] = function (data: any) {
      self.gmoVerifiedCallback(data);
    };
    /* END */

    self.$(function () {
      self.formValidationInit();

      self.$(".tab").click(function () {
        self.$(".is--active").removeClass("is--active");
        self.$(this).addClass("is--active");
        self.$(".is-show").removeClass("is-show");
        const index = self.$(this).index();
        self.$(".panel").eq(index).addClass("is-show");
      });

      /* INIT INPUT ZEN TO HAN */
      self.commonService.zenToHan();
      self.commonService.zenToHan(".zenToHanString", false);
    });
  }

  formValidationInit() {
    new Cleave(".js-card", {
      delimiter: "-",
      blocks: [4, 4, 4, 4],
    });

    new Cleave(".js-date", {
      delimiter: "/",
      blocks: [2, 2],
    });

    /* POSTPAY ONLY */
    if (this.$(".js-zipcode").length != 0) {
      new Cleave(".js-zipcode", {
        delimiter: "-",
        blocks: [7],
      });
    }
  }
}
